const UNITS = ['KB', 'MB', 'GB', 'TB'];

/**
 * 1024-based byte formatting for the details panel's Size row. Whole number for sub-KB values
 * (e.g. "0 B", "512 B"); 1 decimal place from KB upward (e.g. "7.8 MB", "1.2 GB").
 */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${Math.round(bytes)} B`;

  let value = bytes / 1024;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < UNITS.length - 1) {
    value /= 1024;
    unitIndex++;
  }

  return `${value.toFixed(1)} ${UNITS[unitIndex]}`;
}
